/**
 *Created by jmmartinez on 08/4/20
 *
 * 25/05/2021 v1.1 Corregido const {mostrarMenu} = this.props.estado;
 *
 * 09/10/2024 v1.2 Añadida propiedad {soloTitulo}
 * 25/09/2025 v1.3 En el renderSoloTitulo, añadido el boton "Volver" si hay propiedad onVolver
 **/

import React from 'react'
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Button, Icon, Intent} from "@blueprintjs/core";

class Titulo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }

    conmutarDrawer= ()=>{
        const {mostrarMenu} = this.props.estado;

        /*
        if (mostrarMenu)
            this.props.dispatch(estadoChangeDrawerAbierto(true));
        else
            this.props.dispatch(estadoChangePagina(PAGE_MARCAJEOPERARIO))

         */
    }


    volver= () => {
        const {onVolver} = this.props;
        onVolver && onVolver();
    }

    renderSoloTitulo() {
        const {titulo, icon, onVolver} = this.props;
        return (
            <>
                {onVolver &&
                    <Button large={true} style={{margin: 4, float: "right"}}  intent={Intent.PRIMARY} text="Volver" icon="undo"
                            onClick={this.volver}/>
                }

                <div className="titulo"> <Icon style={{margin:4}} iconSize={24} icon={icon}/> {titulo}</div>
            </>
        );
    }

    renderCompleto() {
        const {titulo, onVolver} = this.props;
        const {mostrarMenu} = this.props.estado;
        //console.log("render - titulo - mostrarMenu ", mostrarMenu);
        //console.log("TITULO");
        //console.log("onVolver: ", onVolver);

        //console.log("mostrarMenu :", mostrarMenu == undefined);
        //console.log("Boolean(mostrarMenu) ", Boolean(mostrarMenu));
        let mostrarMenuReal= mostrarMenu == undefined || Boolean(mostrarMenu);
        //mostrarMenuReal= true; //Para pruebas
        //console.log("mostrarMenuReal :", mostrarMenuReal);

        return (
            <div className="titulo">
                {mostrarMenuReal &&
                    <Button large={true} style={{margin: 4}} intent={Intent.PRIMARY} icon="menu" onClick={this.conmutarDrawer}/>
                }
                {titulo}

                {onVolver &&
                    <Button large={true} style={{margin: 4, float: "right"}}  intent={Intent.PRIMARY} text="Volver" icon="undo"
                            onClick={this.volver}/>
                }

                {this.props.children}
            </div>

        )
    }

    render() {
        const {soloTitulo} = this.props;
        let soloTituloReal=  soloTitulo != undefined && Boolean(soloTitulo);

        return (
            <>
                {soloTitulo && this.renderSoloTitulo()}
                {!soloTitulo && this.renderCompleto() }
            </>
        )
    }
}

Titulo.propTypes = {
    titulo: PropTypes.string,
    onVolver: PropTypes.func,
    soloTitulo: PropTypes.bool,
    icon: PropTypes.string,
}



const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Titulo);


